/*
 * Top-level pages of the staff console, which lived on this origin until it
 * moved to its own. Staff still reach them here through bookmarks and history.
 * Segments the app itself uses (journeys, demo) are left out on purpose.
 */
const STAFF_CONSOLE_SEGMENTS = [
  'admin',
  'cohorts',
  'conversation-reviews',
  'dashboard',
  'documents',
  'insights',
  'journey-types',
  'meeting-templates',
  'messages',
  'nps-responses',
  'organisations',
  'skills',
  'topics',
  'tracks',
  'users',
];

/**
 * The same address on the staff console, or null when the path is not one of
 * its pages or the console's origin was not configured at build time.
 */
export function staffConsoleUrl(pathname: string, searchStr: string): string | null {
  const adminUrl: string | undefined = import.meta.env.VITE_ADMIN_URL;
  if (!adminUrl) return null;

  const firstSegment = pathname.split('/')[1] ?? '';
  if (!STAFF_CONSOLE_SEGMENTS.includes(firstSegment)) return null;

  return new URL(`${pathname}${searchStr}`, adminUrl).toString();
}
